export default function React_ES6_Ternary_Operator() {
  return (
    <div>
      <h1>React_ES6_Ternary_Operator Component</h1>
      <p>This is the React_ES6_Ternary_Operator tutorial page.</p>
    </div>
  );
}
